/** `expo-crypto` → WebCrypto. Só o que db/ e lib/ usam. */
export function getRandomBytes(length: number): Uint8Array {
  const out = new Uint8Array(length);
  crypto.getRandomValues(out);
  return out;
}
export function getRandomValues<T extends ArrayBufferView>(array: T): T {
  crypto.getRandomValues(array as unknown as Uint8Array);
  return array;
}
export function randomUUID(): string {
  return crypto.randomUUID();
}
export async function digestStringAsync(_algo: string, data: string): Promise<string> {
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(data));
  return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, '0')).join('');
}
export const CryptoDigestAlgorithm = { SHA256: 'SHA-256' } as const;
